<template>
	<div>
		<div class="btnbox">
			<div class="btn" @click="toShow">打开picker</div>
			<div class="btn" @click="toShow2">切换数据</div>
		</div>
		<div v-show="isCopy" class="isCopy">{{ isCopy }}</div>
		<div class="result">
			<p>----选择结果----</p>
			<p>{{ res }}</p>
		</div>
		<vue-pickers
			:show="show"
			:columns="columns"
			:isRemember="true"
			:selectData="pickData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
const data1 = [
	{
		text: 1999,
		value: 1999
	},
	{
		text: 2001,
		value: 2001
	},
	{
		text: 2002,
		value: 2002
	},
	{
		text: 2003,
		value: 2003
	},
	{
		text: 2004,
		value: 2004
	},
	{
		text: 2005,
		value: 2005
	}
];
const data2 = [
	{
		text: 11111,
		value: 11111
	},
	{
		text: 2222,
		value: 2222
	},
	{
		text: 3333,
		value: 3333
	},
	{
		text: 4444,
		value: 4444
	},
	{
		text: 5555,
		value: 5555
	},
	{
		text: 6666,
		value: 6666
	}
];
export default {
	components: {
		vuePickers
	},
	data() {
		return {
			isCopy: '',
			show: false,
			columns: 1,
			defaultData: [],
			pickData: {
				data1: [],
				data2: []
			},
			res: null
		};
	},
	methods: {
		close() {
			console.log(123);
			this.show = false;
		},
		confirmFn(val) {
			this.show = false;
			this.res = val;
			this.defaultData = [val.select1];
		},
		toShow() {
			this.pickData.data1 = data1;
			this.defaultData = [];
			this.show = true;
		},
		toShow2() {
			this.pickData.data1 = data2;
			this.defaultData = [];
			this.show = true;
		}
	}
};
</script>

<style>
.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/test.vue